import { getObjectKeys } from '@common/utils/getObjectKeys';
import type { ValidationErrors } from '../../../utils/validation';
import type { IDiagnosis } from '../../interfaces/diagnosis';
import { ConclusieDiagnoseOption } from '../../../../common/enums/conclusieDiagnoseOption';
import { CustomControlEntity } from '../../../../common/enums/customControlEntity';
import { ServiceCode } from '../../../../common/enums/serviceCode';

const serviceCodes = [
    ServiceCode.DermaC,
    ServiceCode.DermaSnelC,
    ServiceCode.DermaCwond,
    ServiceCode.GGZCf2f,
    ServiceCode.GGZCg,
    ServiceCode.GGZCmdo,
    ServiceCode.GGZCt,
    ServiceCode.OrthC,
    ServiceCode.TCCh,
    ServiceCode.TCCi,
    ServiceCode.TCCr,
    ServiceCode.TFC,
];

export function validateDiagnosis(
    version: number,
    customControlEntity: CustomControlEntity,
    serviceCode: ServiceCode,
    diagnosis: IDiagnosis,
    errors: ValidationErrors,
    customControlData?: any
) {
    if (!diagnosis || diagnosis.diagnosisConsiderationIcd10 || diagnosis.diagnosisConsiderationIcd10fallback) {
        return errors.remove('diagnosis.diagnosisConsiderationIcd10');
    }

    let hasError = false;
    if (customControlEntity === CustomControlEntity.RequestAddEdit) {
        if (version === 1) {
            if (
                serviceCodes.concat([ServiceCode.TPC, ServiceCode.GTC]).includes(serviceCode) &&
                customControlData &&
                customControlData.conclusie_diagnose === ConclusieDiagnoseOption.ja
            ) {
                hasError = true;
            } else if (
                [ServiceCode.DermaCsc, ServiceCode.DermaSnelCsc].includes(serviceCode) &&
                customControlData &&
                customControlData.conclusie_diagnose === ConclusieDiagnoseOption.ja &&
                !getObjectKeys(customControlData.werkdiagnose).some((key) => customControlData.werkdiagnose[key])
            ) {
                hasError = true;
            }
        }
    } else if (customControlEntity === CustomControlEntity.DiagnosticReportAddEdit) {
        if (version === 1) {
            if (serviceCodes.includes(serviceCode)) {
                if (customControlData && customControlData.conclusie_diagnose === ConclusieDiagnoseOption.ja) {
                    hasError = true;
                }
            } else if (serviceCode === ServiceCode.TPC) {
                if (
                    customControlData &&
                    customControlData.conclusie_diagnose === ConclusieDiagnoseOption.ja &&
                    customControlData.diagnose_COPD_value !== ConclusieDiagnoseOption.ja &&
                    customControlData.diagnose_astma_value !== ConclusieDiagnoseOption.ja
                ) {
                    hasError = true;
                }
            } else if (serviceCode === ServiceCode.GTC) {
                if (!(diagnosis.diagnosisConsiderationIcd10 && diagnosis.diagnosisConsiderationIcd10fallback)) {
                    hasError = true;
                }
            }
        }
    }

    if (hasError) {
        errors = errors.set('diagnosis.diagnosisConsiderationIcd10', 'any_required');
    }

    return errors;
}
